/*
 * @Author: mayanxia
 * @Date: 2022-04-27 16:20:59
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-05-19 11:01:37
 */

<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('设备ID')">
                <j-input :placeholder="$t('输入设备ID模糊查询')" v-model="queryParam.deviceId"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('设备名称')">
                <j-input :placeholder="$t('输入设备名称模糊查询')" v-model="queryParam.deviceName"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('设备类型')">
                <j-dict-select-tag v-model="queryParam.deviceType" :placeholder="$t('请选择设备类型')" dictCode="wq_device_type" ></j-dict-select-tag>
              </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls($t('设备管理'))">{{ $t('导出') }}</a-button>
      <!--
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="deviceNetworkedStatus" slot-scope="text, record">
          <DeviceNetwork :status="record.deviceNetworkedStatus"></DeviceNetwork>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
            <a>{{ $t('删除') }}</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <meter-device-base-modal ref="modalForm" @ok="modalFormOk"></meter-device-base-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction,putAction } from '@/api/manage'
  import { listSize } from '@/utils/util'
  import {isUndefined} from'@/utils/validate'
  import MeterDeviceBaseModal from './modules/MeterDeviceBaseModal'
  import JInput from '@/components/jeecg/JInput'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'MeterDeviceBaseList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      // JDate,
      MeterDeviceBaseModal,
      JInput
    },
    data () {
      return {
        description: 'wq_device管理页面',
        url: {
          list: "/jeecg-charge/wq/meterDeviceBase/list",
          delete: "/jeecg-charge/wq/meterDeviceBase/delete",
          deleteBatch: "/jeecg-charge/wq/meterDeviceBase/deleteBatch",
          exportXlsUrl: "/jeecg-charge/wq/meterDeviceBase/exportXls",
          importExcelUrl: "jeecg-charge/wq/meterDeviceBase/importExcel"
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('设备ID'),
            align:"center",
            dataIndex: 'deviceId'
          },{
            title: this.$t('设备名称'),
            align:"center",
            dataIndex: 'deviceName'
          },{
            title: this.$t('安装位置'),
            align:"center",
            dataIndex: 'deviceLocation'
          },/*{
            title:'运营商',
            align:"center",
            dataIndex: 'iotType',
            customRender: (text) => {
              //字典值替换通用方法
                return filterDictTextByCache('iotType', text);
            },
            width: 80
          },*/{
            title: this.$t('表类型'),
            align:"center",
            dataIndex: 'deviceType',
            customRender: (text) => {
              //字典值替换通用方法
                return filterDictTextByCache('wq_device_type', text);
            },
          },{
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },{
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      handleDetail:function(record){
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title=this.$t('详情');
      this.$refs.modalForm.disableSubmit = true;
    },
    }
  }
</script>
